import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import React from "react";
import { CartProvider } from "./context/CartContext";
//Import main page components
import {
    FullCart,
    MainPage,
    SinglePainting,
    AboutMe,
    Success
} from "./pages";
//Import admin page components
import {
    Orders,
    AllPaintings,
    Login,
    Products,
    AddProduct,
    EditProduct
} from "./pages";
import ProtectedRoute from "./utils/ProtectedRoute";
import { TranslationsProvider } from "./context/TranslationsProvider";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/admin" element={<Login />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<Orders />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/add-product" element={<AddProduct />} />
                    <Route path="/edit-product/:name" element={<EditProduct/>}/>
                </Route>
                <Route
                    path="/*"
                    element={
                        <TranslationsProvider>
                            <CartProvider>
                                <Routes>
                                    <Route path="/" element={<MainPage />} />
                                    <Route path="/all-paintings" element={<AllPaintings />} />
                                    <Route path="/painting/:title" element={<SinglePainting />} />
                                    <Route path="/cart" element={<FullCart />} />
                                    <Route path="/about-me" element={<AboutMe />} />
                                    <Route path="/success" element={<Success />} />
                                </Routes>
                            </CartProvider>
                        </TranslationsProvider>
                    }
                />
            </Routes>
        </Router>
    );
};

export default App;
